<div class="form-group-wrapper" [ngClass]="classes">
  <ng-content select=".form-element"></ng-content>
  @if (!hasError) {
    <div>
      <ng-content select=".note"></ng-content>
      <ng-content select="appError"></ng-content>
    </div>
  }
  @if (hasError) {
    <div>
      <div #appError type="error">
        <div class="alert-message">
          @if (errorsTemplate) {
            <ng-container [ngTemplateOutlet]="errorsTemplate"></ng-container>
          }
          @if (!errorsTemplate) {
            @for (errorCode of formControlErrorCodes; track errorCode) {
              {{ errorMessage(errorCode) }}
            }
          }
        </div>
      </div>
    </div>
  }
</div>
